// eslint-disable-next-line import/prefer-default-export
export const filterUndefined = <T>(arr: Array<T | undefined | null>): Array<T> =>
  arr.filter((val) => val) as Array<T>;
